function PriceColumn({ category }) {
  return (
    <div>
      <h3 className="font-playfair text-2xl sm:text-3xl text-center mb-8" style={{ color: '#c9a84c' }}>
        ― {category.title} ―
      </h3>
      <div className="space-y-8">
        {category.packages.map((pkg, i) => (
          <div key={i}>
            <div className="flex items-baseline justify-between mb-2">
              <span className="font-playfair text-lg text-white">{pkg.duration}</span>
              <span className="flex-1 mx-3 border-b border-dotted border-white/20" />
              <span className="font-montserrat text-lg font-bold text-gold">{pkg.price}</span>
            </div>
            <ul className="space-y-1 ml-2">
              {pkg.items.map((item, j) => (
                <li key={j} className="font-montserrat text-base text-white/60 flex items-start space-x-2">
                  <span className="text-gold/60 text-xs mt-1.5">●</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

function PriceTable({ title, subtitle, priceData }) {
  return (
    <section className="py-10 sm:py-[60px] bg-dark-secondary">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="font-montserrat text-xs tracking-[0.3em] uppercase text-gold mb-4">{subtitle}</p>
          <h2 className="font-playfair text-4xl sm:text-5xl font-bold gold-gradient-text">{title}</h2>
        </div>

        <div className="gold-border p-6 sm:p-10">
          <div className="flex flex-col md:flex-row md:gap-0">
            <div className="flex-1 md:pr-10">
              <PriceColumn category={priceData.standard} />
            </div>
            <div className="hidden md:block w-px bg-gold/20 my-4" />
            <div className="block md:hidden h-px bg-gold/20 my-8" />
            <div className="flex-1 md:pl-10">
              <PriceColumn category={priceData.luxury} />
            </div>
          </div>

          {priceData.extras && (
            <div>
              <div className="h-px bg-gold/20 my-8" />
              <h3 className="font-playfair text-2xl sm:text-3xl text-center mb-8" style={{ color: '#c9a84c' }}>
                ― {priceData.extras.title} ―
              </h3>
              <div className="max-w-md mx-auto space-y-3">
                {priceData.extras.items.map((opt, i) => (
                  <div key={i} className="flex items-baseline justify-between">
                    <span className="font-playfair text-lg text-white">{opt.name}</span>
                    <span className="flex-1 mx-3 border-b border-dotted border-white/20" />
                    <span className="font-montserrat text-lg font-bold text-gold">{opt.price}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default PriceTable;
